import { Box } from "@mui/material"
import CloudOffIcon from "@mui/icons-material/CloudOff"
import { useLayoutBounds } from "@/features/layout/layoutBounds.jsx"
import { useWeatherAvailability } from "./hooks/useWeatherAvailability.jsx"
import { formatUtc } from "./formatUtc.js"

function availabilityText(reason, firstDataIso, lastDataIso) {
  switch (reason) {
    case "before":
      return `No weather at the selected time — data starts ${formatUtc(firstDataIso)} UTC`
    case "after":
      return `No weather at the selected time — data ends ${formatUtc(lastDataIso)} UTC`
    case "none":
      return "No weather data available"
    case "error":
      return "Weather service unavailable"
    default:
      return null
  }
}

export default function WeatherAvailabilityNotice({ controller, geoflowSession, timeOutOfRange }) {
  const bounds = useLayoutBounds()
  const { noticeReason, firstDataIso, lastDataIso } = useWeatherAvailability({
    controller,
    geoflowSession,
    timeOutOfRange,
  })

  const text = availabilityText(noticeReason, firstDataIso, lastDataIso)
  if (!text) return null

  const areaLeft = bounds.leftColumnRight ?? bounds.left
  const areaCenter = (areaLeft + bounds.right) / 2

  return (
    <Box
      role="status"
      sx={{
        position: "fixed",
        left: `${areaCenter}px`,
        transform: "translateX(-50%)",
        bottom: `${bounds.viewportHeight - bounds.bottom}px`,
        zIndex: 999,
        pointerEvents: "none",
        display: "flex",
        alignItems: "center",
        gap: 0.75,
        px: 1.5,
        py: 0.5,
        borderRadius: "999px",
        bgcolor: "rgba(255,255,255,0.9)",
        boxShadow: 1,
        color: "warning.dark",
        fontSize: "12px",
        fontWeight: 600,
        whiteSpace: "nowrap",
      }}
    >
      <CloudOffIcon sx={{ fontSize: 16 }} />
      {text}
    </Box>
  )
}
